import React from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";
import { LoginImg, logopcp } from "../../imagepath";
import { useState ,useEffect} from "react";
import { useNavigate, Link } from "react-router-dom";
import { updateUser } from "../../../lib/auth"

const NewPassword = () => {

    const [eye,seteye] = useState(true);
    const [eye2,seteye2] = useState(true);
    const [passwordInput, setPasswordInput] = useState("");
    const [passwordInput2, setPasswordInput2] = useState("");
    const [validationError, setValidationError] = useState(1);
    const [accessToken, setAccessToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
    const navigate = useNavigate();

    const onEyeClick = () =>{
      seteye(!eye)
    }

    useEffect(() => {
      // Get the access token and refresh token from the URL
      /*
      if (typeof window !== "undefined") {
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        setAccessToken(hashParams.get("access_token") || "");
        setRefreshToken(hashParams.get("refresh_token") || "");
        console.log("newpass",accessToken);
      }
     */
    }, []);

    const onEyeClick2 = () =>{
        seteye2(!eye2)
      }

      const handleSubmit = async (e) => {
        e.preventDefault();
        setValidationError(1);
        if (passwordInput.length < 6)
          {setValidationError(2);
          return;
          }

          if (passwordInput !== passwordInput2)
          {  setValidationError(3);
          return;}

          const { data, error } = await updateUser(passwordInput);
          //console.log("data",data,error);
          if (error)
            setValidationError(error.message);
          else
            navigate("/login/");
      }


      const messages = () => {
        if (validationError == 1) {
          return "";
        } else if (validationError == 2) {
          return (
            <span
              id="poor"
              className="active"
              style={{ fontSize: 16, color: "#DC3545" }}
            >
              😠 Password must be at least 6 characters.
            </span>
          );
        } else if (validationError == 3) {
          return (
            <span
              id="weak"
              className="active"
              style={{ fontSize: 16, color: "#DC3545" }}
            >
              😲 Passwords not match.
            </span>
          );
        } else if (validationError == 4) {
          return (
            <span
              id="strong"
              className="active"
              style={{ fontSize: 12, color: "#0D6EFD" }}
            >
              🙂 Almost. Must contain special symbol
            </span>
          );
        } else if (validationError == 5) {
          return (
            <span
              id="heavy"
              className="active"
              style={{ fontSize: 12, color: "#4BB543" }}
            >
              😊 Awesome! You have a secure password.
            </span>
          );
        }
        else {
          return (
            <span
              id="heavy"
              className="active"
              style={{ fontSize: 16, color: "#DC3545" }}
            >
              😊 {validationError}
            </span>
          );
        }
      };

    var settings = {
        //autoWidth: true,
        items: 2,
        margin: 25,
        dots: true,
        nav: true,
        navText: [
          '<i className="fas fa-arrow-left"></i>',
          '<i className="fas fa-arrow-right"></i>',
        ],
    
        loop: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          768: {
            items: 1,
          },
          1170: {
            items: 1,
          },
        },
    };
  return (
    <>
      <div className="main-wrapper">
        <div className="row">
          {/* Login Banner */}
          <div className="col-md-6 login-bg">

            <OwlCarousel
             {...settings}
             className="owl-carousel login-slide owl-theme">
              <div className="welcome-login">
                <div className="login-banner">
                  <img
                    src={LoginImg}
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h2>
                    Welcome to <br />
                    EduPlus LMS .
                  </h2>
                  <p>
                  
                  </p>
                </div>
              </div>
              <div className="welcome-login">
                <div className="login-banner">
                  <img
                    src={LoginImg}
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h2>
                    Welcome to <br />
                    EduPlus LMS .
                  </h2>
                  <p>
                    
                  </p>
                </div>
              </div>
              <div className="welcome-login">
                <div className="login-banner">
                  <img
                    src={LoginImg}
                    className="img-fluid"
                    alt="Logo"
                  />
                </div>
                <div className="mentor-course text-center">
                  <h2>
                    Welcome to <br />
                    EduPlus LMS .
                  </h2>
                  <p>
                    
                  </p>
                </div>
              </div>
            </OwlCarousel>

          </div>
          {/* /Login Banner */}
          <div className="col-md-6 login-wrap-bg">
            {/* Login */}
            <div className="login-wrapper">
              <div className="loginbox">
                <div className="img-logo">
                  <img
                    src={logopcp}
                    className="img-fluid"
                    alt="Logo"
                  />
                  <div className="back-home">
                    <Link to="/login">Back to Home</Link>
                  </div>
                </div>
                <h1>Setup New Password</h1>
                <form method="post" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label className="form-control-label">Password</label>
                    <div className="pass-group" id="passwordInput">
                    <input className="form-control pass-input"
                     name="passwordInput"
                    value={passwordInput}
                        onChange={(e) => setPasswordInput(e.target.value)}
                         placeholder="Enter your password" type={eye ? "password" : "text"}/>
                    <span onClick={onEyeClick} className={`fa toggle-password feather-eye" ${eye ? "fa-eye" : "fa-eye-slash" }`}/>
                      <span className="pass-checked">
                        <i className="feather-check" />
                      </span>
                    </div>
                    {/*}
                    <div className="password-strength" id="passwordStrength">
                      <span id="poor" />
                      <span id="weak" />
                      <span id="strong" />
                      <span id="heavy" />
                    </div>
                    */}
                    <div id="passwordInfo" />
                  </div>
                  <div className="form-group">
                    <label className="form-control-label">
                      Confirm Password
                    </label>
                    <div className="pass-group" id="passwordInputs">
                    <input className="form-control pass-input"
                     name="passwordInput2"
                     value={passwordInput2}
                         onChange={(e) => setPasswordInput2(e.target.value)}
                    placeholder="Enter your password" type={eye2 ? "password" : "text"}/>
                    <span onClick={onEyeClick2} className={`fa toggle-password feather-eye" ${eye2 ? "fa-eye" : "fa-eye-slash" }`}/>
                      <span className="pass-checked">
                        <i className="feather-check" />
                      </span>
                    </div>
                    {/*}
                    <div className="password-strength" id="passwordStrengths">
                      <span id="poors" />
                      <span id="weaks" />
                      <span id="strongs" />
                      <span id="heavys" />
                    </div>
                    */}
                   <div id="passwordInfo">{messages()}</div>
                  </div>
{/*}
                  <div className="form-check remember-me">
                    <label className="form-check-label mb-0">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="remember"
                      />{" "}
                      I agree to the <Link to="#">Terms of Service</Link> and{" "}
                      <Link to="#">Privacy Policy.</Link>
                    </label>
                  </div>
                  */}
                  <div className="d-grid">
                    <button className="btn btn-start" type="submit">
                      Reset Password
                    </button>
                  </div>
                  <div className="reset-account">
                    <p className="mb-0">
                      Already have an account? <Link to="/login">Sign in</Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
            {/* /Login */}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
